import { css, styled } from "@mui/material";

import { H2WithEmphasisMixin } from "@baseComponents/css";
import { getColor } from "@hooks";
import { cssPropertiesToString } from "@utils";

import { pageMarginY } from "./components";

export const MDXStyles = styled("div")(
  ({ theme }) => css`
    // general --->
    & > p,
    & > h2 {
      ${pageMarginY(theme)}
    }
    // <--- general

    // h2 --->
    ${H2WithEmphasisMixin(theme)}

    & > h2 {
      ${theme.breakpoints.up("mobile")} {
        margin-top: 24px;
      }

      ${theme.breakpoints.up("tablet")} {
        margin-top: 48px;
      }
    }

    & > h2:first-of-type {
      margin-top: 0;
    }
    // <--- h2

    // p --->
    & > p {
      color: ${getColor(c => c.tokens.text["sub-600"], theme)};

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
      }

      // em --->
      & > em {
        font-style: normal;
      }
      & > em:first-of-type {
        color: ${getColor(c => c.foundations.purple[600], theme)};
      }
      & > em:nth-of-type(2) {
        color: ${getColor(c => c.foundations.blue[600], theme)};
      }
      & > em:nth-of-type(3) {
        color: ${getColor(c => c.foundations.teal[600], theme)};
      }
      // <--- em
    }
    // <--- p
  `,
);
